<mat-basic-chip class="celum-chip celum-chip--{{ color() }}" [class.celum-chip--error]="errorTooltip()" disableRipple [disabled]="disabled()">
  @if (prefixIconConfig()) {
    <celum-icon class="celum-chip_prefix-icon" [configuration]="prefixIconConfig()" [matTooltip]="errorTooltip() | translate"></celum-icon>
  }
  @if (prefix()) {
    <span class="celum-chip_prefix">{{ prefix() | translate }}</span>
  }
  <span class="celum-chip_text" spaceAwareTooltip [matTooltip]="text() | translate">{{ text() | translate }}</span>
  @if (!disabled()) {
    <celum-icon
      class="celum-chip_action-icon"
      data-test-celum-chip-remove-button
      [configuration]="closeIconConfig()"
      [matTooltip]="closeIconTooltip() || 'COMMON.REMOVE' | translate"
      (click)="remove.emit(true)"></celum-icon>
  }
</mat-basic-chip>
